import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

// Revoke an API Key in a department
export const revokeAPIKey = async <T extends Record<string, unknown>>({
  data,
  domain,
  headers,
  query,
  departmentId,
  apiKeyId,
  signal,
}: FetchRequestArgs & { departmentId: string; apiKeyId: string }): Promise<
  ReturnType<typeof fetchRequest>
> => {
  return fetchRequest<T>({
    data,
    domain,
    endpoint: `/v2/departments/${departmentId}/api_keys/${apiKeyId}/revoke`,
    headers,
    method: HTTPMethod.DELETE,
    query,
    signal,
  });
};
